const PARAGRAPH_LATEST = (uuid: string, language: string) => `
  paragraphsDataUUID(uuid: "${uuid}", language: "${language}") {
   ... on LatestListing {
      id
      uuid
      type
      heading
      icon
      filteredTypes
      bottomSeparator
      button {
        title
        url
      }
      total
      paginationEnabled
      paginationStyle
      listing(pageNumber: 0) {
        nid
        bundle
        bodyListing
        categories {
          alias
          color
          name
          weight
        }
        featuredImage {
          horizontalCardImage
          alt
        }
        memberOnly
        pathAlias
        publishedOn
        summaryListing
        title
        ... on Article {
          authors {
            title
            pathAlias
          }
          ctaButtons {
            color
            title
            url
          }
          readDuration
        }
        ... on News {
          ctaButtons {
            color
            title
            url
          }
        }
      }
    }
  }
`;

export default PARAGRAPH_LATEST;
